import React from 'react';
import { DisasterEvent } from '../services/disasterDataService';
import { MediaItem } from '../types/MediaItem';
import styles from './Globe.module.css';

interface DisasterCardProps {
  event: DisasterEvent;
  mediaItems?: MediaItem[];
  className?: string;
}

const DisasterCard: React.FC<DisasterCardProps> = ({ 
    event, 
    mediaItems, 
    className 
  }) => {

  const getEventIcon = (type: string) => {
    switch (type) {
      case 'EQ': return '🌋';
      case 'TC': return '🌀';
      case 'FL': return '🌊';
      case 'VL': return '🗻';
      case 'DR': return '☀️';
      case 'WF': return '🔥';
      default: return '⚠️';
    }
  };

  const getAlertClass = (level: string) => {
    switch (level.toLowerCase()) {
      case 'red': return styles.redAlert;
      case 'orange': return styles.orangeAlert;
      case 'green': return styles.greenAlert;
      default: return '';
    }
  };

  return (
    <div className={`${styles.baseCard} ${className || ''}`}>
      <div className="flex items-start justify-between mb-3">
        <span className="text-3xl" role="img" aria-label="event type">
          {getEventIcon(event.eventType)}
        </span>
        <span className={getAlertClass(event.alertLevel)}>
          {event.alertLevel.toUpperCase()}
        </span>
      </div>

      <h3 className={styles.cardTitle}>
        {event.title}
      </h3>

      <div className="space-y-2 mt-4 pt-3 border-t border-white/20">
        <div className="flex justify-between items-center">
          <span className={styles.infoLabel}>Location</span>
          <span className={styles.infoValue}>{event.country || 'Unknown'}</span>
        </div>

        {event.severity && (
          <div className="flex justify-between items-center">
            <span className={styles.infoLabel}>Severity</span>
            <span className={styles.infoValue}>{event.severity}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default DisasterCard;